import { makeAutoObservable, toJS } from 'mobx'

import { ResponseReserveSeats } from 'shared/api/beket/order'

import { FormBeketPassengersValues } from './model'

class BeketFormPassengersStore {
  formPassengers: FormBeketPassengersValues | null = null
  selectedSeats: number[] | [] = []
  seatsResponse: ResponseReserveSeats | Partial<ResponseReserveSeats> = {}

  constructor() {
    makeAutoObservable(this)
  }

  setValuesForm(data: FormBeketPassengersValues) {
    this.formPassengers = data
  }

  clearValuesForm() {
    this.formPassengers = null
  }

  setSelectedSeats(seats: number[]) {
    this.selectedSeats = seats
  }

  getFormPassengerStore() {
    return toJS(this.formPassengers)
  }

  setSeatsResponse(data: ResponseReserveSeats, isForMySelf?: boolean) {
    this.seatsResponse = { ...data, isForMySelf }
  }

  resetState() {
    this.formPassengers = null
    this.selectedSeats = []
    this.seatsResponse = {}
  }
}

export default new BeketFormPassengersStore()
